import { BRANCH_W, INK_SOFT } from '../timelineDiagramGeometry'
import { type BranchpointPlacement } from '../timelineDiagramLayout'
import { ARROWHEAD_MARKER_URL } from './ArrowheadMarker'

// Each branchpoint peels up off the spine as a gentle curved arrow pointing at
// its label on the upper row. Positions come from PLACEMENT.
export const BranchpointRises = ({ branchpoints }: { branchpoints: BranchpointPlacement[] }) => (
  <>
    {branchpoints.map(({ entry, rise }) => (
      <path
        key={entry.detailsId}
        d={rise}
        stroke={INK_SOFT}
        strokeWidth={BRANCH_W}
        markerEnd={ARROWHEAD_MARKER_URL}
      />
    ))}
  </>
)
